import { render, staticRenderFns } from "./MSProposalPolicyholder.vue?vue&type=template&id=5ee6d916"
import script from "./MSProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./MSProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports